import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/app/providers/AuthProvider';
import type { StaffClinance } from '@/types/database';

export function useCurrentStaff(): { staff: StaffClinance | null; loading: boolean } {
  const { profile } = useAuth();

  const { data: staff = null, isLoading: loading } = useQuery({
    queryKey: ['staff', profile?.staff_id],
    enabled: Boolean(profile?.staff_id),
    staleTime: 1000 * 60 * 10,
    queryFn: async () => {
      if (!profile?.staff_id) return null;
      const { data } = await supabase
        .from('staff_clinance')
        .select('*')
        .eq('id', profile.staff_id)
        .single();
      return data;
    },
  });

  return { staff, loading: loading && Boolean(profile?.staff_id) };
}
